import { render } from "./Button.vue?vue&type=template&id=36c61d0a&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=36c61d0a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/fast-blockchains-dashboard/fast-blockchains-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c61d0a"]])

export default __exports__